import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { UserDocumentService } from 'src/app/services/user-document.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'rail-ppe-kit-create-edit',
  templateUrl: './rail-ppe-kit-create-edit.component.html',
  styleUrls: ['./rail-ppe-kit-create-edit.component.scss']
})
export class RailPpeKitCreateEditComponent implements OnInit {
  @Input('formData') PPEKitData
  @Input('activeTab') activeTab
  @Input('_isCreate') _isCreate
  @Input('operativeList') operativeList
  @Output() formClose: EventEmitter<any> = new EventEmitter();

  railPPEForm: FormGroup;
  singlePPEKitData
  clothingSizeList = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL']
  glovesSizeList = ['S', 'M', 'L']
  waistSizeList
  footWareSizeList
  currentTab
  staffList = []
  _formCreate = false
  _isMultiple = false
  loading = false
  userRole = JSON.parse(localStorage.getItem('userRoles'))
  currentUser = JSON.parse(localStorage.getItem('currentUser'))
  selectedUsers = []
  filteredStaffList: any[] = [];
  dynamicHeader
  searchText

  constructor(
    public _formBuilder: FormBuilder,
    public _utilityService: UtilityService,
    public _userDocumentService: UserDocumentService,
    public _cd: ChangeDetectorRef,
  ) {
    this.footWareSizeList = this.generateFootWareSize(3, 15)
    this.waistSizeList = this.generateWasteSize(28, 60)
  }

  ngOnInit(): void {
    this.createForm()
  }


  ngOnChanges(changes: SimpleChanges) {
    console.log("THIS IS THE CHANGES OF ", changes, this.userRole)
    if (changes.PPEKitData && changes.PPEKitData.currentValue) {
      this.singlePPEKitData = changes.PPEKitData.currentValue
      this.dynamicHeader = this.singlePPEKitData.details.ppeName + ' PPE Request'
      this.createForm(this.singlePPEKitData.details)
    } else {
      this.dynamicHeader = 'Record of PPE Issue'
    }
    if (changes.activeTab && changes.activeTab.currentValue) this.currentTab = changes.activeTab.currentValue
    if (changes._isCreate && (changes._isCreate.currentValue || !changes._isCreate.currentValue)) this._formCreate = changes._isCreate.currentValue
    if (changes.operativeList && changes.operativeList.currentValue) {
      this.staffList = changes.operativeList.currentValue
      this.filteredStaffList = this.staffList; // initialize with full list
    }
  }


  // FORM CONTROL



  createForm(ppeFormData?) {
    this.railPPEForm = this._formBuilder.group({
      ppeQue1: new FormControl((ppeFormData && ppeFormData.ppeQue1) ? ppeFormData.ppeQue1 : '', Validators.required),
      ppeQue2: new FormControl((ppeFormData && ppeFormData.ppeQue2) ? ppeFormData.ppeQue2 : '', Validators.required),
      ppeQue3: new FormControl((ppeFormData && ppeFormData.ppeQue3) ? ppeFormData.ppeQue3 : '', Validators.required),
      ppeQue4: new FormControl((ppeFormData && ppeFormData.ppeQue4) ? ppeFormData.ppeQue4 : '', Validators.required),
      ppeQue5: new FormControl((ppeFormData && ppeFormData.ppeQue5) ? ppeFormData.ppeQue5 : '', Validators.required),
      ppeQue6: new FormControl((ppeFormData && ppeFormData.ppeQue6) ? ppeFormData.ppeQue6 : '', Validators.required),
      ppeQue7: new FormControl((ppeFormData && ppeFormData.ppeQue7) ? ppeFormData.ppeQue7 : '', Validators.required),
      ppeQue8: new FormControl((ppeFormData && ppeFormData.ppeQue8) ? ppeFormData.ppeQue8 : '', Validators.required),
      ppeQue9: new FormControl((ppeFormData && ppeFormData.ppeQue9) ? ppeFormData.ppeQue9 : '', Validators.required),
      ppeDate: new FormControl((ppeFormData && ppeFormData.ppeDate) ? ppeFormData.ppeDate : ''),
      ppeName: new FormControl((ppeFormData && ppeFormData.ppeName) ? ppeFormData.ppeName : this.userRole && this.userRole.isOperative ? this.currentUser.name : ''),
      ppeSign: new FormControl((ppeFormData && ppeFormData.ppeSign) ? ppeFormData.ppeSign : ''),
      sE8S: new FormControl((ppeFormData && ppeFormData.sE8S) ? ppeFormData.sE8S : ''),
      sE4S: new FormControl((ppeFormData && ppeFormData.sE4S) ? ppeFormData.sE4S : ''),
      sE6S: new FormControl((ppeFormData && ppeFormData.sE6S) ? ppeFormData.sE6S : ''),
      sE6SC: new FormControl((ppeFormData && ppeFormData.sE6SC) ? ppeFormData.sE6SC : ''),
      sE7S: new FormControl((ppeFormData && ppeFormData.sE7S) ? ppeFormData.sE7S : ''),
      // ppeItems: new FormControl((ppeFormData && ppeFormData.ppeItems) ? ppeFormData.ppeItems : [])
      ppeItems: this._formBuilder.array(this.multiplePPEItems([]))
    })
  }


  get getPPEItems() {
    return this.railPPEForm.get('ppeItems') as FormArray;
  }

  multiplePPEItems(ppeItemList: any[]) {
    console.log("PPE LIST", ppeItemList)
    let ppeItemsFormArray = [];
    if (ppeItemList && ppeItemList.length) {
      _.forEach(ppeItemList, (singlePPEItem) => {
        console.log("ITEM", typeof singlePPEItem.ppeName, singlePPEItem.ppeName)
        ppeItemsFormArray.push(new FormGroup({
          ppeDate: new FormControl(singlePPEItem && singlePPEItem.ppeDate ? singlePPEItem.ppeDate : '', Validators.required),
          ppeName: new FormControl(singlePPEItem && singlePPEItem.ppeName ? singlePPEItem.ppeName : '', Validators.required),
          ppeSign: new FormControl(singlePPEItem && singlePPEItem.ppeSign ? singlePPEItem.ppeSign : '', Validators.required),
          // instructorId: new FormControl(singlePPEItem && singlePPEItem._id ? singlePPEItem._id : ''),
        }));
      });
      return ppeItemsFormArray;
    } else {
      return [this._formBuilder.group({
        ppeDate: new FormControl(''),
        ppeName: new FormControl(''),
        ppeSign: new FormControl(''),
        // instructorId: new FormControl(''),
      })];
    }
  }

  // UTILITY

  generateFootWareSize(start, end) {
    return _.range(start, end + 1, 1)
  }

  generateWasteSize(start, end) {
    return _.range(start, end + 2, 2)
  }

  closeForm(type?) {
    this.createForm()
    this._isMultiple = false
    this.selectedUsers = []
    this.formClose.emit({ type: type })
  }

  onChange(event, fomrControl, formGroup) {
    console.log("DATE SELECT EVENT", event)
    formGroup.get(fomrControl).patchValue(event)
    console.log("AFTER DATE VALUE ASSIGNED", formGroup.value)
  }


  onMultipleDateChange(event, index) {
    this.getPPEItems.at(index).patchValue({
      ppeDate: event,
    })
  }

  addSignature(formControl, index) {
    const dialogRef = this._utilityService.commonDialogBoxOpen(SignaturePadComponent, 'user')
      .afterClosed().subscribe((data) => {
        if (data == undefined) return
        else {
          console.log("FORM CONTROL WIRH INDEX", formControl, index)
          if (this.userRole.isAdmin) {
            this.getPPEItems.at(index).patchValue({
              ppeSign: data,
            })
          } else {
            this.railPPEForm.get('ppeSign').patchValue(data)
          }
          console.log("AFTER UPDATE THE VALUE", this.railPPEForm.value)
          // formGroup.get(formControl).patchValue(data)
          // console.log("AFTER SIGNATURE ASSIGNED", formGroup.value)
        }
      })
  }


  operativeSelect(event, user) {
    console.log("EVENT", event.value)
    console.log("USER DATA", user)
    // this._isMultiple = false
    if (event.value && event.value.length) {
      const control = <FormArray>this.railPPEForm.controls.ppeItems
      while (control.length) { control.removeAt(0); }
      event.value.filter((x) => {
        control.push(this._formBuilder.group({
          ppeDate: new FormControl('', Validators.required),
          ppeSign: new FormControl('', Validators.required),
          ppeName: new FormControl(x.name, Validators.required),
          instructorId: new FormControl(x._id),
        }))
      })
      this._isMultiple = true
      this._cd.detectChanges()
    } else {
      this._isMultiple = false
    }
  }

  filterStaffList() {
    const search = this.searchText.toLowerCase();
    console.log("SEARCH TEXT WITH LIST", search, this.staffList)
    this.filteredStaffList = this.staffList.filter(staff =>
      staff.name.toLowerCase().includes(search) || this.selectedUsers.includes(staff)
    );
  }

  // API CALL


  approvePPEKit() {
    this.loading = true
    console.log("when user is approved");
    let obj = {}
    if (this.singlePPEKitData && this.singlePPEKitData.instructorId) {
      obj['isPPEKit'] = true
      obj['content'] = 'approve'
      obj['isOperativeUser'] = false
    } else {
      obj['isPPEKit'] = true
      obj['content'] = 'approve'
      obj['isOperativeUser'] = true
    }
    this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, obj).afterClosed().subscribe((res) => {
      console.log("RESPONSE OF ARCHIVE STAFF", res)
      if (res === undefined) return
      if (res === 'yes') {
        this.loading = true;
        this._userDocumentService.approvePPEKitRequest(this.singlePPEKitData._id).subscribe((instructors) => {
          console.log("===instructorsinstructorsinstructorsinstructors===", instructors)
          // this.getPPEKitList()
          this.closeForm('_isCreate')
          this._formCreate = false
          this.loading = false;
          this._utilityService.openSnackBar('PPE Kit Approved Successfully', 'Ok')
        }, (error) => {
          console.log("approve users some error occure ", error)
          this.loading = false
        });
      }
    })
  }


  rejectPPEKit() {
    // this.loading = true;
    let obj = {}
    if (this.singlePPEKitData && this.singlePPEKitData.instructorId) {
      obj['_isPPEKitReject'] = true
      obj['content'] = 'reject'
      obj['isOperativeUser'] = false
    } else {
      obj['_isPPEKitReject'] = true
      obj['content'] = 'reject'
      obj['isOperativeUser'] = true
    }
    this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, obj).afterClosed().subscribe((res) => {
      if (res === undefined) return
      if (res === 'yes') {
        this._userDocumentService.rejectPPEKitRequest(this.singlePPEKitData._id).subscribe((instructors) => {
          console.log("===instructorsinstructorsinstructorsinstructors===", instructors.data)
          // this.getPPEKitList()
          this.loading = false;
          this._utilityService.openSnackBar('PPE Kit Rejected Successfully', 'Ok')
        }, (error) => {
          console.log("approve users some error occure ", error)
          this.loading = false
        });
      }
    })
  }


  submitPPEKitForm() {
    if (this.railPPEForm.valid) {
      this.loading = true
      console.log("CURRENT FORM DATA", this.railPPEForm.value)
      this._userDocumentService.addPPEKitRequest(this.railPPEForm.getRawValue()).subscribe((res) => {
        console.log("RES", res)
        this.closeForm('_isCreate')
        this._formCreate = false
        this._utilityService.openSnackBar('PPE Kit Request Created Successfully', 'Ok')
        this.loading = false
      }, error => {
        console.log("ERROR WHILE ADD PPE KIT", error)
        this.loading = false
      })
    } else {
      console.log('ERROR', this.railPPEForm)
      this.railPPEForm.markAllAsTouched()
    }
  }

}
